export const headers = [
  {
    key: "requestId",
    label: "Request ID",
  },
  {
    key: "businessName",
    label: "Business Name",
  },
  {
    key: "primaryContactName",
    label: "Primary Contact Name",
  },
  {
    key: "businessType",
    label: "Business Type",
  },
  {
    key: "requestedDate",
    label: "Request Date",
  },
  {
    key: "status",
    label: "Status",
  },
  //  {
  //      key:"action",
  //      label:"Action",
  //  }
];

export const providerRequestFilterOptions = [
  {
    label: "Status",
    value: "status",
    type: "checkbox",
    options: [
      { label: "Pending", value: "pending" },
      { label: "Approved", value: "approved" },
      { label: "Rejected", value: "rejected" },
    ],
  },
  
  {
    label: "Business Type",
    value: "businessType",
    type: "checkbox",
    options: [
      {
        value: "Funeral & Memorial Service Providers",
        label: "Funeral & Memorial Service Providers",
      },
      { value: "Aftercare & Grief Support", label: "Aftercare & Grief Support" },
      {
        value: "Transportation & Logistics",
        label: "Transportation & Logistics",
      },
      { value: "Products & Supplies", label: "Products & Supplies" },
      {
        value: "Cremation Services",
        label: "Cremation Services",
      },
      { value: "Technology & Media", label: "Technology & Media" },
      {
        value: "Religious & Cultural Services",
        label: "Religious & Cultural Services",
      },
      {
        value: "Vendor Services",
        label: "Vendor Services",
      },
    ],
  },
  {
    label: "Requested Date Range",
    value: "requestedDateRange",
    type: "dateRange",
  },
];
